import React from 'react';
import { NavLink } from 'react-router-dom';

import PanelContainer from 'components/PanelContainer';
import BasicButton from 'components/BasicButton';
import Avatar from 'components/Avatar';
import LinkBuilder from 'helpers/link-builder';

import './styles.css';

const PersonConnectBlock = props => {
  const { item, onConnectHandler } = props;
  const {
    CandidateID,
    FullName,
    FirmName,
    FirmUrlAlias,
    PictureUrl,
    SchoolName,
    OfficeLocationName,
    currentSchoolName,
    RoleID,
    ViewProfile,
  } = item;

  const handleConnect = () => {
    onConnectHandler({ id: CandidateID });
  };

  const isStudent = Number(RoleID) === 4;

  return (
    <PanelContainer styles={{ padding: 0 }}>
      <div className="person-connect-block">
        <div className="person-connect-block__content">
          <div className="person-connect-block__avatar">
            <Avatar
              size={160}
              link={
                ViewProfile === 'Yes'
                  ? LinkBuilder.getProfileLink(CandidateID)
                  : null
              }
              name={FullName}
              image={PictureUrl}
            />
          </div>

          <div className="person-connect-block__info">
            {ViewProfile === 'Yes' ? (
              <NavLink
                className="person-connect-block__name"
                to={LinkBuilder.getProfileLink(CandidateID)}
              >
                {FullName}
              </NavLink>
            ) : (
              <strong>{FullName}</strong>
            )}
            {isStudent || !FirmName ? (
              <div className="person-connect-block__firm">
                {currentSchoolName}
              </div>
            ) : (
              <NavLink
                to={LinkBuilder.getFirmLink(FirmUrlAlias)}
                className="person-connect-block__firm"
              >
                {FirmName}
              </NavLink>
            )}
            <span className="person-connect-block__school">{SchoolName}</span>
            <span className="person-connect-block__office">
              {OfficeLocationName}
            </span>
          </div>
        </div>
        <div className="person-connect-block__control">
          <BasicButton
            btnWidth={200}
            btnHeight={40}
            btnFontWeight={600}
            btnText="Connect"
            btnArrow={false}
            controlFunc={handleConnect}
            btnBg="#fff"
            btnHoverBg="#f40"
          />
        </div>
      </div>
    </PanelContainer>
  );
};

export default PersonConnectBlock;
